import { dateToStr, getDefaultValue } from "components/CommonLib/CommonLib";
import CheckBox from "components/LabelInput/CheckBox";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import NormalBtn from "components/NewButton/NormalBtn";
import { globalModalOff } from "modules/actions/Modal";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useDailyReportStore } from "../modules/store/dailyReportState";
import { DailySalesModalBody, DailySalesModalFooter } from "./style";

const DailySalesModal = ({
  hqBranchListData,
  setHqIdx,
  onClickSearch,
  setSearchParams,
  excelOptions,
  setExcelOptions,
}) => {
  const storesDispatch = useDispatch();
  // 페이지 구성 변수
  const labelWidth = "4.5rem";
  const optionLabelWidth = "6.5rem";
  const comboWidth = "13rem";
  const { hq_list, target_list } = hqBranchListData;
  // 전역 상태 관리
  const { dailyReportSearchParams: searchParams } = useDailyReportStore();

  // 최초의 엑셀용 검색조건 세팅
  const initSearchParams = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const yesterdayStr = dateToStr(yesterday);

    setSearchParams("base_from_date", yesterdayStr);
    setSearchParams("base_to_date", yesterdayStr);
    setSearchParams("hq_info", target_list[0].hq_info);
    setSearchParams("branch_info", target_list[0].branch_list[0]);
  };

  // 체크박스 변경
  const handleCheckboxChange = (key) => {
    setExcelOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    initSearchParams();

    return () => {
      // 바로 하면 자료가 이상하게 나옴
      setTimeout(() => {
        setSearchParams("hq_info", hqBranchListData.target_list[0].hq_info);
        setSearchParams("branch_info", hqBranchListData.target_list[0].branch_list[0]);
        setSearchParams("base_from_date", "");
        setSearchParams("base_to_date", "");
        setHqIdx(0);
      }, 500);
    };
  }, []);

  return (
    <>
      <DailySalesModalBody>
        <ComboBox
          labelWidth={labelWidth}
          comboItemWidth={comboWidth}
          labelText="본부"
          labelMarginRight="0rem"
          data={hq_list}
          defaultValue={getDefaultValue("combo", hq_list[0])}
          onChangeCallback={(e, idx) => {
            const hqParams = hqBranchListData.target_list[idx].hq_info;
            setSearchParams("hq_info", hqParams);
          }}
          required
        />
        <DatePicker
          labelText="날짜"
          labelWidth={labelWidth}
          textBoxWidth={comboWidth}
          labelMarginRight="0rem"
          textMarginRight="0rem"
          defaultValue={getDefaultValue("field", searchParams.base_from_date)}
          onChangeCallback={(e) => {
            setSearchParams("base_from_date", e);
            setSearchParams("base_to_date", e);
          }}
        />
        {/* 옵션 선택 */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5rem" }}>
          <CheckBox
            labelText="회원권"
            labelWidth={optionLabelWidth}
            defaultValue={excelOptions.mbshp_total_sales}
            onChangeCallback={() => handleCheckboxChange("mbshp_total_sales")}
          />
          <CheckBox
            labelText="부가상품"
            labelWidth={labelWidth}
            defaultValue={excelOptions.other_total_sales}
            onChangeCallback={() => handleCheckboxChange("other_total_sales")}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <CheckBox
            labelText="회원권+부가상품"
            labelWidth={optionLabelWidth}
            defaultValue={excelOptions.mbshp_and_other_total_sales}
            onChangeCallback={() => handleCheckboxChange("mbshp_and_other_total_sales")}
          />
          <CheckBox
            labelText="PT"
            labelWidth={labelWidth}
            defaultValue={excelOptions.pt_total_sales}
            onChangeCallback={() => handleCheckboxChange("pt_total_sales")}
          />
        </div>
      </DailySalesModalBody>
      <DailySalesModalFooter>
        <NormalBtn
          name="취소"
          theme="white"
          onClick={() => {
            storesDispatch(globalModalOff());
          }}
        />
        <NormalBtn
          theme="green"
          name={"다운로드"}
          onClick={() => {
            onClickSearch(1, true);
            setTimeout(() => {
              storesDispatch(globalModalOff());
            }, 300);
          }}
        />
      </DailySalesModalFooter>
    </>
  );
};

export default DailySalesModal;
